import React, { useEffect, useState } from 'react';
import { States } from '@/helpers/common/states';
import api, { AxiosError } from '@/services/api';
import { toast } from 'react-toastify';
import { EventSectionSaleProductReport } from '@/model/EventSectionSaleProductReport';
import { ReportControllerProps } from '../../types';
import { SaleProductSectionsContent } from './ui';

interface StateProps {
  reportController: ReportControllerProps;
  setState: (state: States) => void;
}

export const SaleProductSections: React.FC<StateProps> = ({
  reportController,
  setState,
}): JSX.Element => {
  const { eventId, singleEvent } = reportController;
  const [sections, setSections] = useState<EventSectionSaleProductReport[]>([]);

  const handleGetSaleProducts = async (): Promise<void> => {
    try {
      setState(States.loading);
      const { data } = await api.get<EventSectionSaleProductReport[]>(
        `event/report/${eventId}/sale-product/section?singleEvent=${singleEvent}`,
      );
      if (data) {
        setSections(data);
      }
    } catch (error) {
      const err = error as AxiosError;
      toast.error(err.message);
    } finally {
      setState(States.default);
    }
  };

  useEffect(() => {
    handleGetSaleProducts();
  }, []);
  return <SaleProductSectionsContent sections={sections} />;
};
